// @mui material components
import Grid from "@mui/material/Grid";

// Admin panel React components
import MDBox from "components/MDBox"
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import MDInput from "components/MDInput";
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { CircularProgress, TextField, OutlinedInput, InputAdornment, IconButton, DialogActions, Dialog, DialogTitle, DialogContent, Typography, Box, InputLabel, MenuItem, FormControl, Select } from '@mui/material'
import { green } from "@mui/material/colors";
import CheckIcon from '@mui/icons-material/Check';

// Admin panel React example components
import * as React from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Footer from "examples/Footer";
import MDSnackbar from "components/MDSnackbar";
import { useContext } from "react";
import { AuthContext } from "context/AuthContext";

// Data
import salesNameTable from "layouts/addSale/data/SalesNameTable";


//firestore
import { db, storage } from "../../firebase"
import { collection, doc, addDoc, getDoc, getDocs, where, query ,setDoc} from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

//modal Styles
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function AddSale() {
  const { columns, rows } = salesNameTable();
  const { currentUser, role } = useContext(AuthContext)
  const [brandsSaleModal, setBrandsModal] = React.useState(false);
  const [brandsSaleNotification, setBrandsSaleNotification] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [about, setAbout] = React.useState('');
  const [Htitle, setHtitle] = React.useState('');
  const [website, setWebsite] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');

  const [posterImageProgress, setPosterImageProgress] = React.useState(0);
  const [posterImageProgressValue, setPosterImageProgressValue] = React.useState(0);
  const [bannerImageProgress, setBannerImageProgress] = React.useState(0);
  const [bannerImageProgressValue, setBannerImageProgressValue] = React.useState(0);
  const [selectedBrand, setSelectedBrand] = React.useState('');
  const [brandsDropdown, setBrandsDropdown] = React.useState([])
  const [brandDbData, setBrandDbData] = React.useState({})
  const [posterFile, setPosterFile] = React.useState('')
  const [bannerFile, setBannerFile] = React.useState('')
  const [brandsSaleData, setBrandsSaleData] = React.useState({
    title: '',
    percentage: '',
    startDate: '',
    endDate: '',
    saleURL: '',
    location: ''
  })

 


  const fetchAllBrands = async () => {
    // get data from database
    const getAllDocs = await getDocs(collection(db, "Jobs"));
    const dbData = getAllDocs.docs.map((items) => ({ id: items.postuid, ...items.data() }))
   

   
  };
  React.useEffect(() => {
    role === "admin" && fetchAllBrands()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchAllBrands2 = async (selectedBrand) => {
    // get data from database
    const q = query(collection(db, "users"), where("uid", "==", currentUser))
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setSelectedBrand(doc.data().brandName)
    })

    const q2 = query(collection(db, "brands"), where("name", "==", selectedBrand))
    const querySnapshot2 = await getDocs(q2);
    querySnapshot2.forEach((doc) => {
      setBrandDbData(doc.data())
    })
  };

  const onAddBrandSale = async (e) => {
    e.preventDefault()
    //post data into firestore
   let contactmethod =
  email.length > 0
    ? "email"
    : phone.length > 0
    ? "phone"
    : website.length > 0
    ? "web"
    : "";
    
    try {
      setLoading(true)
      const docId =  await addDoc(collection(db, "Jobs"), {
        About: about,
        Address: "",
        Htitle: Htitle,
        Categories: "Other (General)",
        Categorieslist: ["1"],
        Location: {},
        dateEx:new Date(new Date().setDate(new Date().getDate() + 15)),
        published: true,
        mail:email,
        WeekDays: [],
        hash:'sv9tc1j79',
        avgRating: 0,
        isProject:false,
        backimg:
          selectedBrand,
        business: "",
        businessHide: false,
        catar: "أخرى",
        hprice: "",
        Availablility:3,
        web:website,
        mprice:"",
            priceper: "0",
            yearsofx:"<1",
            noapplied:0,
        createdAt: new Date(Date.now()),
        priceav: false,
        dateor: "",
        curr: 0,
        noorders: 0,
        end: new Date(Date.now()),
        facebook: "",
        imgs: [selectedBrand],
        isBusiness:true,
        Country:"Jordan",
        contactmethod:contactmethod,
        deliverTime: 0,
        linkedin: "",
        paymentmethod: [],
        nofollowers: 0,
        noview: 0,
        onlinebusiness: false,
        phone: phone,
        postuid: null,
        time: new Date(Date.now()),
        updatedAt: new Date(Date.now()),
        user: "Samer alsukhni",
        verfied: false,
        whats: "",
        writerId: "X8r6URM5MTDtuuxNITLC",
        ownerid: "Sqst1H0JrbVrHtrMd2CEKGmz2Bj1",
        youtube: "",
          })
          const updateData = {
            postuid: docId.id
          }
          const DocRef = doc(db, "Jobs", docId.id)
          await setDoc(DocRef, updateData, { merge: true });
          const botToken = '7232220220:AAFecs22QEvv_vV3mxF6o0hIbnjvqjDG8ek'; // Replace with your bot token
          const chatId = '@fekra_arabia'; // Use the '@' symbol for channels or groups
      
          const message = `قدم للوظيفة الآن:
          ${Htitle}
    
          ${about}
    
           ${"https://fekra.page.link/VVnUBgqyo2LFtnhQ6"}`;
          const response = await fetch(
            `https://api.telegram.org/bot${botToken}/sendPhoto`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                chat_id: chatId,
                photo: selectedBrand, // URL of the image or file ID if already uploaded
                caption: message, // Optional: Add a caption to the photo
        
              }),
            }
          );
    
          const data = await response.json();
    
    
      brandsSaleModalClose()
    }
    catch (error) {
      setError(error.code)
      setLoading(false)
    }
  }
  const brandsSaleModalOpen = () => setBrandsModal(true);
  const brandsSaleModalClose = () => {
    setBrandsModal(false)
    setLoading(false)
    setError('')
    setPosterImageProgress(0)
    setPosterImageProgressValue(0)
    setBannerImageProgress(0)
    setBannerImageProgressValue(0)
  };
  const brandsSaleNotificationOpen = () => setBrandsSaleNotification(true);
  const brandsSaleNotificationClose = () => setBrandsSaleNotification(false);
  return (
    <>
      <MDSnackbar
        color="success"
        icon="check"
        title="Successfully Add"
        // content="Hello, world! This is a brandsSaleNotification message"
        // dateTime="11 mins ago"
        open={brandsSaleNotification}
        onClose={brandsSaleNotificationClose}
        close={brandsSaleNotificationClose}
      />

      <BootstrapDialog
        onClose={brandsSaleModalClose}
        aria-labelledby="customized-dialog-title"
        open={brandsSaleModal}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={brandsSaleModalClose} fullWidth>
          <Typography variant="h3" color="secondary.main" sx={{ pt: 1, textAlign: "center" }}>اضافة وظيفة</Typography>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 2, maxWidth: "100%", display: "flex", direction: "column", justifyContent: "center" },
            }}
            noValidate
            autoComplete="off"
          >
            <Box sx={{ maxWidth: "100%", m: 2 }}>
              <FormControl fullWidth >
                <InputLabel id="demo-simple-select-label" sx={{ height: "2.8rem" }} required>البلد</InputLabel>
                <Select
                  sx={{ height: "2.8rem" }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="بلد"
                  value={selectedBrand}
                  onChange={(e) => setSelectedBrand(e.target.value)}
                >
                  {[{id:'1',name:'الاردن',link:'https://i.ibb.co/pR23QL9/Yellow-and-White-Modern-Hiring-Team-Banner-1.jpg'},{id:'2',name:'السعودية',link:'https://i.ibb.co/HHzT7QV/Yellow-and-White-Modern-Hiring-Team-Banner-2.jpg'}].map((items) => {
                    return (
                      <MenuItem key={items.id} value={items.link}>{items.name}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Box> 
            <MDInput
              type="text"
              label="اسم الوظيفة"
              required
              value={Htitle}
              onChange={(e) => setHtitle(e.target.value)}
            />
          <textarea
  placeholder="وصف"
  required
  style={{maxWidth: "100%",width:400}}
  value={about}
  onChange={(e) => setAbout(e.target.value)}

  rows={6} // You can set the number of rows
/>

           
            <MDInput
              type="url"
              label="Website"
              required
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
           
           <MDInput
              type="url"
              label="phone"
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
           
           <MDInput
              type="url"
              label="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}

            />
          
           
            {error === '' ? null :
              <MDBox mb={2} p={1}>
                <TextField
                  error
                  id="standard-error"
                  label="Error"
                  InputProps={{
                    readOnly: true,
                    sx: {
                      "& input": {
                        color: "red",
                      }
                    }
                  }}
                  // defaultValue="Invalid Data!"
                  value={error}
                  variant="standard"
                />
              </MDBox>}
            <MDBox mt={1} p={1} sx={{ display: 'flex', direction: 'row', justifyContent: "center" }}>
              {loading ?
                <CircularProgress
                  size={30}
                  sx={{
                    color: green[500],
                  }}
                /> : <MDButton variant="contained" color="info" type="submit"
                  // disabled={brandsSaleData.title === '' || brandsSaleData.percentage === '' || brandsSaleData.saleURL === '' || brandsSaleData.location === '' ? true : false}
                  onClick={onAddBrandSale}
                >حفظ</MDButton>
              }
            </MDBox>
          </Box>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>

      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDBox pt={2} pb={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="medium" color="white">
                        جميع الوظائف
                      </MDTypography>
                      <MDButton variant="gradient" color="light"
                        onClick={() => {
                          brandsSaleModalOpen()
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        &nbsp;اضافة وظيفة
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default AddSale;
